import { CheckoutAbTestMetric } from "@redotech/redo-conversion-core-common/checkouts/checkout-ab-test-utils";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { orderValueFilterSchema } from "./get-all-checkout-split-metrics";

const checkoutMetricData = z.object({
  valuesByTreatment: z.array(
    z.object({ treatmentId: zExt.objectId(), value: z.number() }),
  ),
  // Making nullable until we have a way to calculate confidence
  // for all metrics.
  variantConfidencesByTreatment: z
    .array(z.object({ treatmentId: zExt.objectId(), confidence: z.number() }))
    .nullable(),
});

export const calculateCheckoutSplitResults = {
  name: "calculateCheckoutSplitResults" as const,
  input: z.object({
    splitId: zExt.objectId(),
    orderValueFilter: orderValueFilterSchema.optional(),
  }),
  output: z.object({
    [CheckoutAbTestMetric.CHECKOUT_CONVERSION_RATE]: checkoutMetricData,
    [CheckoutAbTestMetric.AVERAGE_SHIPPING_REVENUE]: checkoutMetricData,
    [CheckoutAbTestMetric.REVENUE_PER_CHECKOUT_VISIT]: checkoutMetricData,
    [CheckoutAbTestMetric.AVERAGE_ORDER_VALUE]: checkoutMetricData,
  }),
};

export type CalculateCheckoutSplitResultsOutput = z.infer<
  typeof calculateCheckoutSplitResults.output
>;
